import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkLink } from 'uitk-react-link';
import { UitkPillContainer } from 'uitk-react-pill';
import { UitkSpacing } from 'uitk-react-spacing';

import { PlaybackFilterPill } from './playback-filter-pill';

export interface PlaybackFilterProps extends RouteComponentProps {
  centerPills?: boolean;
  wrapPills?: boolean;
  hideRemoveAllButtonsCTA?: boolean;
  searchResults?: SearchResultsStore;
  analytics?: any;
}

@inject('searchResults', 'analytics')
@observer
export class PlaybackFilterComponent extends React.Component<PlaybackFilterProps> {
  private removeAllFilters = () => {
    const { searchResults, history, location } = this.props;
    searchResults?.clearFilters(history as any, location as any);
  };

  public render() {
    const { analytics, searchResults, wrapPills, centerPills, hideRemoveAllButtonsCTA } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = (sortAndFilter && sortAndFilter.pills) || [];
    const defaults = sortAndFilter && sortAndFilter.defaults;

    const playbackPills = pills.map((pill: any) => (
      <PlaybackFilterPill key={`playback-filter-${pill.name}-${pill.value}`} pill={pill} disabled={isLoading} defaults={defaults} />
    ));

    if (playbackPills.length < 1) {
      return null;
    }

    const a11yHeadingMessage =
      playbackPills.length === 1 ? 'hotels.searchResults.singleFilter.a11yLabel' : 'hotels.searchResults.multiFilters.a11yLabel';

    const renderRemoveAllCTA = !hideRemoveAllButtonsCTA && wrapPills && pills.length > 1;
    const removeAllCTAButton = renderRemoveAllCTA ? (
      <UitkSpacing padding={{ block: 'two' }} margin={{ blockstart: 'three', inline: 'one' }}>
        <div>
          <UitkLink
            size="small"
            inline={true}
            onClick={this.removeAllFilters}
            analytics={analytics && analytics.setupTracker('playback.removeAllFilters', 'Remove all filters applied', null)}
          >
            <button disabled={isLoading}>
              <LocalizedText message="hotels.searchResults.playbackFilter.removeAllFilters.linkText" />
            </button>
          </UitkLink>
        </div>
      </UitkSpacing>
    ) : null;

    const playbackElements = [...playbackPills, removeAllCTAButton];

    const pillContainerAlignment = centerPills ? 'center' : undefined;
    const shouldRenderFilterPills = !searchResults?.searchCriteria?.vacationRentalsOnly;
    const uitkPillContainer = (
      <UitkPillContainer wrap={wrapPills} align={pillContainerAlignment} dataTestId="playback-filter-pill-container">
        {playbackElements}
      </UitkPillContainer>
    );

    const pillContainer = wrapPills ? <UitkSpacing margin={{ blockend: 'three' }}>{uitkPillContainer}</UitkSpacing> : uitkPillContainer;

    return (
      <section>
        <h3 className="is-visually-hidden">
          <LocalizedText message={a11yHeadingMessage} />
        </h3>
        {shouldRenderFilterPills ? pillContainer : null}
      </section>
    );
  }
}

export const PlaybackFilter = withRouter(PlaybackFilterComponent);
PlaybackFilter.displayName = 'PlaybackFilter';
